import { kpLiveApi } from '@/services/kursi-play-v2/kpLiveApiClient';
import { supabase } from '@/utils/supabase';
import type { LearningProgress } from '@/types/canonicalLearning';

export const unifiedProgressService = {
  async getPathProgress(slug: string, userId: string): Promise<LearningProgress> {
    const data = await kpLiveApi.getWorldHome(slug, userId);
    const totalLessons = Array.isArray(data.lessons) ? data.lessons.length : 0;
    const completedLessons = (data.lessons ?? []).filter((l) => l.status === 'completed').length;

    return {
      userId,
      courseSlug: slug,
      completedLessons,
      totalLessons,
      completionPercent: totalLessons > 0 ? Math.round((completedLessons / totalLessons) * 100) : 0,
      xpTotal: Number(data.progress.total_xp_earned ?? 0),
      streakDays: Number(data.progress.current_streak_days ?? 0),
      nextLessonId: data.progress.next_lesson_id ?? null,
    };
  },

  async completeLesson(params: {
    lessonId: string;
    slug: string;
    userId: string;
    guestSessionToken?: string;
  }) {
    if (params.guestSessionToken) {
      const { data, error } = await supabase.functions.invoke('kp-complete-lesson', {
        body: {
          lesson_id: params.lessonId,
          slug: params.slug,
          user_id: params.userId,
          guest_session_token: params.guestSessionToken,
        },
      });
      if (error) throw new Error(error.message);
      if (!data?.success) throw new Error(data?.error ?? 'שגיאה בסיום שיעור');
      return data;
    }

    return kpLiveApi.completeLesson(params.lessonId, params.slug, params.userId);
  },
};
